module.exports = __webpack_public_path__ + "img/wallet-more-active.87a7f87a.png";